import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const keyOf = (i) => `${i.product_id}|${i.size || ""}|${i.color || ""}|${i.customization?.placement || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("abs_cart") || "[]"));
  const [open, setOpen] = useState(false);
  const [discount, setDiscount] = useState(() => JSON.parse(localStorage.getItem("abs_discount") || "null"));

  useEffect(() => localStorage.setItem("abs_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("abs_discount", JSON.stringify(discount)), [discount]);

  const add = (product, { size, color, quantity = 1, customization = null } = {}) => {
    const chosenSize = size ?? product.sizes?.[0] ?? null;
    const price = product.variants?.find((v) => v.name === chosenSize)?.price ?? product.price;
    const item = { product_id: product.id, name: product.name, price, image: product.image, is_digital: !!product.is_digital,
      size: chosenSize, color: color ?? product.colors?.[0] ?? null, quantity, stock: product.stock, customization };
    setItems((prev) => {
      const found = prev.find((p) => keyOf(p) === keyOf(item));
      if (found) return prev.map((p) => (p === found ? { ...p, quantity: Math.min(p.quantity + quantity, product.stock) } : p));
      return [...prev, item];
    });
    toast.success(`${product.name} added to cart`);
    setOpen(true);
  };

  const update = (key, quantity) =>
    setItems((prev) => prev.map((p) => (keyOf(p) === key ? { ...p, quantity } : p)).filter((p) => p.quantity > 0));
  const remove = (key) => setItems((prev) => prev.filter((p) => keyOf(p) !== key));
  const clear = () => { setItems([]); setDiscount(null); };

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, count, subtotal, open, setOpen, keyOf, discount, setDiscount }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
